import traceActionsCreator from '../traceActionsCreator'

import { TFetchTransmittersResponse } from './ServiceTypes/fetchTransmitters.ServiceTypes'

export const fetchTransmittersServiceName = 'Transmitter/fetchTransmitters'
export const fetchTransmittersTraceActions =
  traceActionsCreator<TFetchTransmittersResponse>(fetchTransmittersServiceName)
